import { queryEquipList, goodsDetail } from '@/pages/services/equip'
import { openRecruit } from '@/utils/appAgreement'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
const back = (data: any) => {
  if (!!data.data && data.data.status === 500) {
    toast(data.data.err)
    setTimeout(() => {
      openRecruit()
    }, 1000)
  }
}
export default {
  namespace: 'equipCertification',

  state: {},

  subscriptions: {
    setup () {
      // eslint-disable-line
    }
  },

  effects: {
    // 查询装备列表
    * getEquipList ({ payload: value }, { call, put, select }) {
      // eslint-disable-line
      try {
        const { data } = yield call(queryEquipList, value)
        const result = data.data
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    }
  },

  reducers: {}
}
